import { escapeHtml } from './escapeHtml';
import { parseSolfegeToken } from './earTrainingSolfegeTokens';

/** HTML for one solfege token (syllable only — register comes from melody order). */
export function renderSolfegeTokenHtml(token: string): string {
  const { syllable } = parseSolfegeToken(token);
  const label = escapeHtml(syllable);
  return `<span class="ear-training-solfege-token">${label}</span>`;
}

/** Hyphen-separated solfege line for reveal panel. */
export function formatSolfegeTokensLineHtml(tokens: readonly string[]): string {
  return tokens
    .filter(Boolean)
    .map(t => renderSolfegeTokenHtml(t))
    .join('<span class="ear-training-solfege-sep" aria-hidden="true">-</span>');
}
